/*eslint no-undef: "off"*/

import { useQuery } from '@tanstack/vue-query'

export const DATA_MONTH_QUERY_KEY = ['neuron', 'stats']

const DEFAULT_OPTIONS = {
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
}

export async function getDataMonth({ queryKey }) {
    const [, endpoint] = queryKey

    // All other nueron calls are pre-pended with /api. This one is not
    const neuronBaseUrl = import.meta.env.VITE_API_URL_NEURON.replace(/\/api\/?$/, '')

    const response = await fetch(`${neuronBaseUrl}/${endpoint}`, {
        headers: { accept: 'application/json' },
    })

    if (!response.ok) {
        throw new Error(`GET /stats responded with ${response.status}`)
    }

    const { month, year, lastDate, lookbackYear } = (await response.json()) ?? {}

    if (!month || !year || !lastDate || !lookbackYear) {
        throw new Error('GET /stats response is missing data month fields')
    }

    return { month, year, lastDate, lookbackYear }
}

export function useQueryDataMonth({ queryKey = DATA_MONTH_QUERY_KEY, options = {} } = {}) {
    return useQuery({
        queryKey,
        queryFn: ({ queryKey }) => getDataMonth({ queryKey }),
        ...DEFAULT_OPTIONS,
        ...options,
    })
}
